import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  recentAlerts: [],
  loading: false,
  activeTableHeaders: [],
  defaultTableHeaders: [],
}

const recentAlertsSlice = createSlice({
  name: 'recentAlerts',
  initialState,
  reducers: {
    setRecentAlerts: (state, action) => {
      state.recentAlerts = action.payload
    },
    setRecentAlertsLoading: (state, action) => {
      state.loading = action.payload
    },
    setActiveTableHeaders: (state, action) => {
      state.activeTableHeaders = action.payload
    },
    setDefaultTableHeaders: (state, action) => {
      state.defaultTableHeaders = action.payload
    },
  },
})

export const { setActiveTableHeaders, setDefaultTableHeaders } =
  recentAlertsSlice.actions

export default recentAlertsSlice.reducer
